<!-- ワンタッチパスコンポーネント (一覧) -->
<template>
    <div>
        <div v-if="showLoading" class="jleague_loader">

        </div>
        <form method="post" ref="removeOneTouchPassForm" v-show="!showLoading">
            <input :value="csrf"
                   :name="csrfName"
                   type="hidden">
            <input :value="token"
                   name="token"
                   type="hidden">
            <input v-model="jsonPatchForUserInfo"
                   name="userinfo_patch"
                   type="hidden">

            <template v-if="displayOneTouchList.length">
                <div v-for="pass in displayOneTouchList" class="oneTouchContainer">
                    <table>
                        <tr>
                            <th>ワンタッチパスID</th>
                            <td>{{ pass.otp_id }}</td>
                        </tr>
                        <tr>
                            <th>クラブ</th>
                            <td>{{ pass.club_cd | clubTeamName }}</td>
                        </tr>
                        <tr>
                            <th>グレード</th>
                            <td>{{ pass.member_classification_nm }}</td>
                        </tr>
                        <tr>
                            <th>有効開始日</th>
                            <td>{{ pass.member_effective_start_ymd | dateFormat }}</td>
                        </tr>
                        <tr>
                            <th>有効終了日</th>
                            <td>{{ pass.member_effective_end_ymd | dateFormat }}</td>
                        </tr>
                    </table>
                    <div>
                        <button @click.prevent="removeOneTouchPass(pass)"
                                type="button"
                                class="return">解除</button>
                    </div>
                </div>
            </template>
            <div v-else>
                <p class="msg"><em class="errNote">ワンタッチパスが未登録です</em></p>
            </div>

            <div class="btnSpace duo single-on-sp">
                <button @click="backToHome"
                        type="button"
                        class="return">メニューに戻る</button>
                <button @click="addOneTouchPass"
                        name="registration"
                        type="button">ワンタッチパスIDを追加する</button>
            </div>
        </form>
    </div>
</template>

<script>
import jsonpatch from 'fast-json-patch'
import dayjs from 'dayjs'
import { mixinJleague, mixinOneTouchPass } from '../../mixin/utility'

export default {
    name: 'OneTouchListForm',
    mixins: [mixinJleague, mixinOneTouchPass],
    data: function(){
        return {
            userInfoPatch: {},
            jsonPatchObserver: {},
            jsonPatchForUserInfo: '',
            targetOneTouchPass: null,
            today_ymd: null,
            showLoading: false
        }
    },
    props: {
        csrf: {
            type: String,
            required: true
        },
        csrfName: {
            type: String,
            required: true
        },
        token: {
            type: String,
            required: true
        },
        userinfo: {
            type: Object,
            required: true
        },
        isVisible: {
            type: Boolean,
            required: true
        }
    },
    computed: {
        today: function(){
            return dayjs()
        },
        /**
         * 渡された値が過去の日付のとき true
         * @returns {function(*=): boolean}
         */
        isPastEffectiveYmd: function(){
            return (pass) => {
                // `isAfter` だと当日を含まない
                // `isSameOrAfter` だとプラグインが必要
                return dayjs(pass.member_effective_end_ymd).isBefore(this.today, 'date')
            }
        },
        /**
         * `member_effective_end_ymd` が過去の日付のワンタッチパスを除外して返す
         * @returns {*}
         */
        displayOneTouchList: function(){
            return this.oneTouchPassObjects.filter((item) => {
                return !this.isPastEffectiveYmd(item)
            })
        },
    },
    created: function(){
        this.userInfoPatch = Object.assign({}, this.userinfo);
        this.jsonPatchObserver = jsonpatch.observe(this.userInfoPatch);

        if (!this.userInfoPatch.otpmember_view) this.userInfoPatch.otpmember_view = [];
        this.today_ymd = dayjs().format('YYYYMMDD');
    },
    filters: {
        clubTeamName: function(code){
            return jleagueClubList.getClubTeamName(code);
        },
        dateFormat: function(date){
            return dayjs(date).format('YYYY年MM月DD日');
        }
    },
    methods: {
        addOneTouchPass: function(){
            this.$emit('toggle-element', !this.isVisible);
        },
        generateJsonPatch: function(){
            const self = this;

            return new Promise(function(resolve){
                // オブジェクトを `,` と `=` 区切りの文字列に変換する
                const target = Object.entries(self.targetOneTouchPass).map(function(element){
                    return element.join('=');
                }).join(',');

                // 対象を削除する
                const index = self.oneTouchPassToArray.indexOf(target);
                self.oneTouchPassToArray.splice(index, 1);
                if (self.oneTouchPassToArray.length === 0) {
                    // 0件のときは null で登録する
                    self.userInfoPatch.otpmember_view = null;
                } else if (self.oneTouchPassToArray.length === 1) {
                    // 残りが1件のときは配列ではなく文字列で登録する
                    self.userInfoPatch.otpmember_view = self.oneTouchPassToArray[0];
                }
                let jsonPatchData = jsonpatch.generate(self.jsonPatchObserver)
                jsonPatchData.push(
                  { "op": "add", "path": "/sfdc_necessary_api_call_mode", "value": "1" },
                  { "op": "add", "path": "/sfdc_sync_cancel_otpmember_view", "value": "1" }
                )
                self.jsonPatchForUserInfo = JSON.stringify(jsonPatchData);
                resolve(self.jsonPatchForUserInfo);
            });
        },
        removeOneTouchPass: async function(target){
            if (target.member_classification_cd && (
                target.member_classification_cd === "a0X0I00000H5XcHUAV" ||
                target.member_classification_cd === "a0X0I00000HgVseUAF" ||
                target.member_classification_cd === "a0X0I00000HgVuqUAF" ||
                target.member_classification_cd === "a0X0I00000HgVxPUAV" ||
                target.member_classification_cd === "a0X0I00000HgVxyUAF" ||
                target.member_classification_cd === "a0X0I00000HgVzOUAV" )) {
                this.$emit('show-error', true);
                return;
            } else {
                this.$emit('show-error', false);
            }

            if(window.confirm('解除してよろしいですか？')){
                const form = this.$refs.removeOneTouchPassForm;
                try {
                    this.showLoading = true;

                    this.targetOneTouchPass = target;
                    await this.generateJsonPatch();

                    form.submit();
                } catch (e) {
                    this.showLoading = false;
                }
            }else{
                return;
            }
        },
    }
}
</script>
